import { useCallback } from "react";
import { createLocalStorageStateHook } from "use-local-storage-state";
import useTheme from "@material-ui/core/styles/useTheme";
import getTheme, { defaultThemeName, inverseThemeName } from "../themes";
export const useConfigThemeState = createLocalStorageStateHook("themeName", defaultThemeName);
export const useThemeType = () => {
  const activeTheme = useTheme();
  return activeTheme.palette.type;
};
export const useThemeSwitch = () => {
  const [theme, setTheme] = useConfigThemeState();
  return useCallback(() => {
    const themeName = inverseThemeName(theme);
    setTheme(themeName);
    return themeName;
  }, [setTheme, theme]);
};
export const useConfigTheme = () => {
  const [themeName] = useConfigThemeState();
  return getTheme(themeName);
};